import Divider from '@mui/material/Divider';
import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import SectionBody from './SectionBody';
import SectionHeader from './SectionHeader';

// $isFirst is a transient prop that does not reach the DOM so it can be a 'bool' instead of 'string'
const SectionContainer = styled('div')(({ theme, $isFirst }) => ({
	minWidth: 320,
	marginBottom: theme.spacing(2),
	marginTop: $isFirst ? theme.spacing(2) : 0,
}));

function Section({ header = '', isFirst, ...props }) {
	const hasHeader = Boolean(header);

	return (
		<SectionContainer $isFirst={isFirst}>
			{hasHeader && (
				<>
					<SectionHeader>{header}</SectionHeader>
					<Divider />
				</>
			)}

			<Box sx={{ mt: hasHeader ? 2 : 0 }}>
				<SectionBody {...props} />
			</Box>
		</SectionContainer>
	);
}

Section.propTypes = {
	header: PropTypes.any,
	isFirst: PropTypes.bool,
	children: PropTypes.any.isRequired,
};

export default React.memo(Section);
